import { Controller } from "@hotwired/stimulus"

// A sent image in the chat (_upload_chip): opens full size in a native modal <dialog>. Esc (native),
// the × button or a click on the backdrop closes it; a modified click still opens a new tab.
export default class extends Controller {
  open(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey) return
    event.preventDefault()
    const dialog = document.createElement("dialog")
    dialog.className = "laz-img-dialog"
    dialog.innerHTML = `<button type="button" class="laz-img-dialog-close" title="Close (Esc)" aria-label="Close">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button><img>`
    const img = dialog.querySelector("img")
    img.src = this.element.href
    img.alt = this.element.title
    dialog.querySelector("button").addEventListener("click", () => dialog.close())
    dialog.addEventListener("click", (e) => { if (e.target === dialog) dialog.close() }) // the backdrop
    dialog.addEventListener("close", () => dialog.remove())
    document.body.appendChild(dialog)
    dialog.showModal()
  }
}
